export const FETCH_REQUEST = 'REPORT_TEMPLATE.FETCH_REQUEST';
export const FETCH_SUCCESS = 'REPORT_TEMPLATE.FETCH_SUCCESS';
export const FETCH_FAILURE = 'REPORT_TEMPLATE.FETCH_FAILURE';

export const GET_REQUEST = 'REPORT_TEMPLATE.GET_REQUEST';
export const GET_SUCCESS = 'REPORT_TEMPLATE.GET_SUCCESS';
export const GET_FAILURE = 'REPORT_TEMPLATE.GET_FAILURE';

export const SAVE_REQUEST = 'REPORT_TEMPLATE.SAVE_REQUEST';
export const SAVE_SUCCESS = 'REPORT_TEMPLATE.SAVE_SUCCESS';
export const SAVE_FAILURE = 'REPORT_TEMPLATE.SAVE_FAILURE';

export const DELETE_REQUEST = 'REPORT_TEMPLATE.DELETE_REQUEST';
export const DELETE_SUCCESS = 'REPORT_TEMPLATE.DELETE_SUCCESS';
export const DELETE_FAILURE = 'REPORT_TEMPLATE.DELETE_FAILURE';

export const SET_PROPERTY = 'REPORT_TEMPLATE.SET_PROPERTY';


// WEBPACK FOOTER //
// ./src/constants/ReportTemplate.ts